<script>
import common from "@/mixins/common.vue";
import {mapActions} from "vuex";

export default {
  name: "PaymentDetail",
  props: {
    event: String,
    title:String,
    visible: Boolean,
  },
  data(){
    return {
      email: '',
      coins: [],
      selectedCoinId: '',
      selectedVendor: 'ATM',
      referralCode: '',
      loading: false,
      saveLoading: false,
    }
  },
  mixins:[common],
  created() {
    this.loadData();
  },
  computed: {
    paymentVendorList() {
      return [
          'Newebpay','ECPAY','JKO','ATM'
      ]
    }
  },
  methods: {
    ...mapActions(['loadCoinsList', 'createATMOrder']),
    async loadData(){
      try {
        const res = await this.loadCoinsList();
        const result = res.data;
        if (result.statusCode === 0){
          this.coins = result.data;
        }
      } catch (e) {
        console.log(`loadCoinsList error `, e);
      }
    },
    cancelEvent(){
      this.$emit('cancelEvent');
    },
    async confirmEvent(){
      await this.save();
    },
    async save(){
      try {
        this.saveLoading = true;
        const res = await this.createATMOrder({
          productId: this.selectedCoinId,
          email: this.email,
          referralCode: this.referralCode,
          vendor: this.selectedVendor
        });

        const result = res.data;
        if (result && result.statusCode === 0){
          this.showMessageDialog('成功',result.message);
          this.$emit('confirmEvent');
        } else {
          this.showMessageDialog('提示',result.message ? result.message :'建立訂單失敗！');
        }
      } catch (e) {
        console.log(`createATMOrder error ` , e);
        this.showMessageDialog('提示','建立訂單失敗！');
      } finally {
        this.saveLoading = false
      }
    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
  }
}
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="'80%'">
    <v-card >
      <v-card-title>匯款訂單</v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <v-text-field  v-model="email"
                           :label="'Email'"
                           :color="Theme.GREEN"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field  v-model="referralCode"
                           :label="'推薦碼'"
                           :color="Theme.GREEN"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-if="isAdmin">
          <v-select
              :color="Theme.GREEN"
              :items="paymentVendorList"
              :label="'金流'"
              v-model="selectedVendor"/>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-select
                      :color="Theme.GREEN"
                      :items="coins"
                      :label="'儲值金額'"
                      item-text="name" item-value="coinId"
                      v-model="selectedCoinId"/>
          </v-flex>
        </v-layout>

      </v-card-text>
      <v-card-actions>
        <v-btn  :color="Theme.PINK" dark @click="cancelEvent">取消</v-btn>
        <v-spacer></v-spacer>
        <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>
